import config from '../config';
import messageFactory from './wss/MessageFactory.js';
import systemStreamer from './wss/SystemStreamer.js';
import logService from './wss/logService3.js';
import reconnectManager from './ReconnectManager';
import { StreamEvents } from './wss/StreamEvents';
import AppContext from '../controllers/AppContext';

const _name = 'AuthService';

class AuthService {
    initStreamer = async (token) => {
        try {
            if (token === null) {
                return false;
            }

            reconnectManager.init(systemStreamer);

            const r = await systemStreamer.start();

            const tabId = AppContext.getTabId();
            const payload = messageFactory.createRequest(StreamEvents.onUserAuthenticated, token, tabId);
            const msg = messageFactory.serialize(payload);
            const send = await systemStreamer.send(msg);

            this.streamerInitialized = send;
            return this.streamerInitialized;
        } catch (error) {
            logService.logError(`${_name}.initStreamer: ${error.message}`);
        }
    };

    cleanup = async () => {
        try {
            return await systemStreamer.stop();
        } catch (error) {
            logService.logError(`${_name}.cleanup: ${error.message}`);
        }
    };

    isConnected = () => {
        try {
            if (systemStreamer.isConnected) return true;
            return false;
        } catch (error) {
            logService.logError(`${_name}.isConnected: ${error.message}`);
        }
    };
}

const authService = new AuthService();
export default authService;
